import React, { useContext, useEffect } from 'react';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import { ChatMessage, Text } from 'pcln-design-system';
import MessageFooter from '../MessageFooter/MessageFooter';
import { TravelBotLogoImage } from '../../TravelBotLogoImage';
import { CitationsSources } from './CitationsSources';
import { SimpleMarkdownLine } from './SimpleMarkdownLine';
import { mapPinType } from '../../constants';
import { expressDealHotelId } from '../../HotelComponent/useSetHotelPinOnMapHook';
import analytics from '../../analytics/analytics';
import { useChatUIContext } from '../../hooks/useChatUIContext';
import { mapManager } from '../Maps/googleMapManager';
export const MarkdownElementsComponent = props => {
  const {
    webSearchResult,
    mdElementLines,
    metadataCollection
  } = props;
  const {
    appendNewPinToList,
    hotelOnMapList
  } = useContext(ChatbotDataContext);
  const {
    setIsMapOpened
  } = useChatUIContext();
  const googlePin = [];
  const citationsMeta = [];
  for (const pin of metadataCollection) {
    if (pin.type === 'CITATION') {
      citationsMeta.push(pin);
    } else {
      const googleMapPin = pin;
      googlePin.push(googleMapPin);
    }
  }
  useEffect(() => {
    appendNewPinToList({
      listOfPins: googlePin
    });
  }, []);
  function handleMapButtonClick(pinsInCurrentLine, targetPin) {
    if ((targetPin === null || targetPin === void 0 ? void 0 : targetPin.type) === mapPinType.HOTEL && (targetPin === null || targetPin === void 0 ? void 0 : targetPin.hotelId)) {
      // Find hotel result from existing hotel result
      const hotelPin = hotelOnMapList === null || hotelOnMapList === void 0 ? void 0 : hotelOnMapList.find(p => {
        var _a;
        const hotel = p === null || p === void 0 ? void 0 : p.hotel;
        if ((hotel === null || hotel === void 0 ? void 0 : hotel.hotelType) === 'SOPQ') {
          const expressId = expressDealHotelId(hotel);
          return expressId === targetPin.hotelId;
        } else {
          return String((_a = p === null || p === void 0 ? void 0 : p.hotel) === null || _a === void 0 ? void 0 : _a.hotelId) === String(targetPin.hotelId);
        }
      });
      // If hotel result is found, open hotel detail page
      if (hotelPin && (hotelPin === null || hotelPin === void 0 ? void 0 : hotelPin.hotelDetailURL)) {
        analytics.log({
          label: 'HotelSearchResult',
          hotelId: hotelPin.hotelId,
          message: 'HOTEL_DETAIL_LINK_CLICKED',
          clickedOnPennMessage: 'Y'
        });
        window.open(hotelPin.hotelDetailURL, '_blank');
        return;
      }
    } else {
      setIsMapOpened(true);
      mapManager.addCallback(() => {
        mapManager.fitBoundsOnCurrentMap(pinsInCurrentLine).catch(() => {});
      });
    }
  }
  return React.createElement(ChatMessage, {
    mb: 4,
    variation: 'initial',
    Icon: TravelBotLogoImage,
    message: React.createElement(React.Fragment, null, mdElementLines.map((elementsInLine, i) => {
      return React.createElement(Text, {
        mb: 1,
        key: `markdown-line-${i}`
      }, React.createElement(SimpleMarkdownLine, {
        elements: elementsInLine,
        handleMapButtonClick: handleMapButtonClick
      }));
    }), (citationsMeta === null || citationsMeta === void 0 ? void 0 : citationsMeta.length) > 0 && React.createElement(CitationsSources, {
      citationsMeta: citationsMeta,
      webSearchResult: webSearchResult
    })),
    footer: React.createElement(MessageFooter, null)
  });
};